/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Регион
 * @export
 * @interface TravelineRegionDto
 */
export interface TravelineRegionDto {
    /**
     * Идентификатор региона
     * @type {string}
     * @memberof TravelineRegionDto
     */
    id: string;
    /**
     * Название региона
     * @type {string}
     * @memberof TravelineRegionDto
     */
    name: string;
    /**
     * Трехбуквенный идентификатор страны
     * @type {string}
     * @memberof TravelineRegionDto
     */
    countryCode: string;
}

/**
 * Check if a given object implements the TravelineRegionDto interface.
 */
export function instanceOfTravelineRegionDto(value: object): value is TravelineRegionDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    return true;
}

export function TravelineRegionDtoFromJSON(json: any): TravelineRegionDto {
    return TravelineRegionDtoFromJSONTyped(json, false);
}

export function TravelineRegionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineRegionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'countryCode': json['countryCode'],
    };
}

  export function TravelineRegionDtoToJSON(json: any): TravelineRegionDto {
      return TravelineRegionDtoToJSONTyped(json, false);
  }

  export function TravelineRegionDtoToJSONTyped(value?: TravelineRegionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'countryCode': value['countryCode'],
    };
}

